/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/no-inferrable-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PanelContainerComponent, PanelHeaderComponent, PanelBodyComponent } from "src/app/shared/content-panels";
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule } from '@angular/material/table';
import { SerialNumberDefects } from '../models/defect-history.model';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-defect-detail-view',
  imports: [
    PanelContainerComponent,
    PanelHeaderComponent,
    MatIconModule,
    PanelBodyComponent,
    MatTableModule,
    MatTooltipModule
],
  templateUrl: './defect-detail-view.component.html',
  styleUrl: './defect-detail-view.component.scss',
})
export class DefectDetailViewComponent {
  @Input() defectViewItem: any;
  @Input() serialNumber: string = '';
  @Output() closeDetailView = new EventEmitter<void>();

  tableColumns = [
    'ZoneName',
    'Section',
    'Station',
    'TaskName',
    'Category',
    'Code',
    'DefectLoc',
    'DefectQuantity',
    'DefectDesc',
    'Images'
  ]

  testData: SerialNumberDefects[] = [
    {
      ZoneName: 'Zone 1',
      Section: 'A',
      Station: '1',
      TaskName: 'Is the polarity tests being completed in accordance with DAPIA approved Quality procedures? (observe complete test with procedure)',
      Category: 'CCI',
      Code: '11.7',
      DefectLoc: 'Bedroom 4',
      DefectQuantity: 1,
      DefectDesc: 'Defect Description 1',
      Images: ['image1.jpg']
    },
    {
      ZoneName: 'Zone 2',
      Section: 'B',
      Station: '3',
      TaskName: 'Is cement lap and panel siding stored per MFG instructions?',
      Category: 'CCI, AOC',
      Code: '11.7, 1B',
      DefectLoc: 'Entry Way',
      DefectQuantity: 1,
      DefectDesc: 'Defect Description that is longer and will need to be truncated',
      Images: [ "longerAttachmentNameofImage.jpg", "image2.jpg" ]
    }
  ]

  ngOnInit() {
    console.log('Defect View Item:', this.defectViewItem);
    console.log('Serial Number:', this.serialNumber);
  }

  closePanel() {
    this.closeDetailView.emit();
  }

  previewPhoto(image: string) {
    console.log('Previewing photo:', image);
    // Implement the logic to preview the photo, e.g., open a modal or new window
  }

}
